// extracted by mini-css-extract-plugin
export default {"summary-card":"Campaigns_summary-card__LJ+7y","list-card":"Campaigns_list-card__MrMj+"};